export const scrollToBottom = (element: Element) => {
  element.scrollTop = element.scrollHeight;
};
